// import { styled, ThemeColorName, pickTextColor, pickColor } from '../../theme';

import { IconName, IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon as _FontAwesomeIcon, FontAwesomeIconProps as _FontAwesomeIconProps } from '@fortawesome/react-fontawesome';


export type FontAwesomeIconName = IconName;
export const FontAwesomeIcon = _FontAwesomeIcon;
export type FontAwesomeIconProps = _FontAwesomeIconProps;
export type FontAwesomeIconProp = IconProp;